<ion-header class="ion-no-border">
  <ion-toolbar>
    <ion-buttons slot="start" (click)="closeModal()">
      <ion-back-button mode="md"></ion-back-button>
    </ion-buttons>
    <ion-title>Kontaktperson</ion-title>
    @if (platform.is('capacitor')) {
      <ion-buttons slot="end">
        <ion-button slot="icon-only" style="box-shadow: none;" (click)="openQrCode()">
          <ion-icon name="fa-qr-code"></ion-icon>
        </ion-button>
      </ion-buttons>
    }
  </ion-toolbar>
</ion-header>

<ion-content NoScrollbar class="ion-padding">
  <div class="acp-item">
    <h2>Anrede</h2>
    <input type="text" placeholder="Herr, Frau ..." class="template-input" [(ngModel)]="contactPerson.salutation">
  </div>
  <div class="acp-item">
    <h2>Vorname</h2>
    <input type="text" placeholder="Max ..." class="template-input" [(ngModel)]="contactPerson.firstName">
  </div>
  <div class="acp-item">
    <h2>Nachname</h2>
    <input type="text" placeholder="Mustermann ..." class="template-input" [(ngModel)]="contactPerson.lastName">
  </div>
  <div class="acp-item">
    <h2>Telefon</h2>
    <input type="tel" pattern='[0-9]{8}([0-9]{2})?' placeholder="0123456789 ..." class="template-input" [(ngModel)]="contactPerson.telefone">
  </div>
  <div class="acp-item">
    <h2>Handy</h2>
    <input type="tel" pattern='[0-9]{8}([0-9]{2})?' placeholder="0123456789 ..." class="template-input" [(ngModel)]="contactPerson.mobile">
  </div>
  <div class="acp-item">
    <h2>E-Mail</h2>
    <input type="email" placeholder="beispiel@email.de ..." class="template-input" [(ngModel)]="contactPerson.email">
  </div>
  <div class="acp-item">
    <h2>Abteilung</h2>
    <input type="text" placeholder="Vertrieb ..." class="template-input" [(ngModel)]="contactPerson.department">
  </div>

  <!-- @if (generalSrv.webConfig.hasCustomerLogin) {
    <div class="acp-item">
      <h2>Online-Zugang</h2>
      <ion-toggle mode="ios" slot="end" [(ngModel)]="onlineAccess"></ion-toggle>
    </div>
  } -->

</ion-content>

<ion-footer class="ion-no-border">
  <div class="c-bttn" (click)="save()">
    Speichern
  </div>
</ion-footer>
